const defaultRoute = {
  name: "Dashboard - Page 1"
}

export default {
  methods: {
    safeBack(route = defaultRoute, forceRoute = false) {
      const fromStored = sessionStorage.getItem("prevRoute");
      const fromMeta = this.$route?.meta?.from;
      const fromResult = fromMeta || fromStored;

      // Determine the target from route
      const target = !forceRoute && fromResult ? fromResult : null;

      if (target && target !== this.$route.fullPath && target.startsWith("/")) {
        // Route validation can be added to check if route exists:
        const resolved = this.$router.resolve(target)
        if (resolved?.route?.matched?.length) {
          return this.$router.push(target).catch(() => {}); // suppress NavigationDuplicated
        }
      }

      // Fallback to default route
      return this.$router.push(route).catch(() => {});
    }
  }
}
